import { render } from "./QuranAyatFavorit.vue?vue&type=template&id=4a840709"
import script from "./QuranAyatFavorit.vue?vue&type=script&lang=js"
export * from "./QuranAyatFavorit.vue?vue&type=script&lang=js"
script.render = render

export default script